// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"27c94421","531":"b7547a6c","558":"b7547a6c","806":"b7547a6c"}[chunkId] + ".chunk.css";
};